import React, { useState } from "react";
import "./rummy_round_history.css";
import "../RummyTableHistoryInnerRoundCards/RummyTableHistoryInnerRoundCards.css";
import "../RummyTableHistoryInnerRound/RummyTableHistoryInnerRound.css";
import { Button, Modal } from "react-bootstrap";
import RummyTableHistoryInnerRoundCards from "../RummyTableHistoryInnerRoundCards/RummyTableHistoryInnerRoundCards";

function PointsRummyHistory(props) {
  const [rummyWalletHistoryCards, setRummyWalletHistoryCards] = useState([]);

  const [showRummyWalletHistory, setShowRummyWalletHistory] = useState(false);

  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal rc-modal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Rummy Round History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="rummy-history-table-wrapper">
            <table className="rummy-history-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Player Name</th>
                  <th>Winning Points</th>
                  <th>Lose Points</th>
                  <th>Winning Amount</th>
                  <th>Lose Amount</th>
                  <th>Win Status</th>
                  <th>Cards</th>
                </tr>
              </thead>

              <tbody>
                {props?.rummyWalletHistory?.length > 0 ? (
                  props.rummyWalletHistory.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.name || "-"}</td>
                      <td className="text-success">{item.win_point ?? "-"}</td>
                      <td className="text-danger">{item.loss_point ?? "-"}</td>
                      <td className="text-success">
                        ₹ {item.win_amount ?? "-"}
                      </td>
                      <td className="text-danger">
                        ₹ {item.loss_amount ?? "-"}
                      </td>
                      <td
                        className={
                          item.win_loss ? "text-success" : "text-danger"
                        }>
                        {item.win_loss ? "Win" : "Loss"}
                      </td>
                      <td>
                        <Button
                          className="rs-view-btn"
                          onClick={() => {
                            setShowRummyWalletHistory(true);
                            setRummyWalletHistoryCards(
                              item?.RummyPointGameHistoryCards,
                            );
                          }}>
                          View
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="no-history">
                      No round history found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <RummyTableHistoryInnerRoundCards
        onHide={() => setShowRummyWalletHistory(false)}
        show={showRummyWalletHistory}
        rummyWalletHistoryCards={rummyWalletHistoryCards}
      />
    </div>
  );
}

export default PointsRummyHistory;
